/**
 * Smooth scroll utility function for navigation
 * @param targetId - The ID of the element to scroll to
 * @param offset - Optional offset from the top (useful for fixed headers)
 */
export const smoothScrollTo = (targetId: string, offset = 80) => {
  const element = document.getElementById(targetId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

/**
 * Navigate to a section with smooth scrolling
 * @param navigate - React Router navigate function
 * @param language - Current language
 * @param sectionId - The section ID to scroll to
 * @param offset - Optional offset from the top
 */
export const navigateToSection = (
  navigate: (path: string) => void,
  language: string,
  sectionId: string,
  offset = 80
) => {

  if (window.location.pathname !== `/${language}/#${sectionId}`) {
    navigate(`/${language}/#${sectionId}`);
    // Wait for navigation to complete, then scroll
    setTimeout(() => {
      smoothScrollTo(sectionId, offset);
    }, 100);
  } else {
    smoothScrollTo(sectionId, offset);
  }
};
